import SectionHeader from './SectionHeader';
import { hexToRgba } from '../../utils/helpers';
import { MONO_FACE } from '../../constants/templates';

export default function SummarySection({ data, template, accent }) {
  const s = data.summary;
  const hasContent = s && (s.tagline || (s.bullets && s.bullets.length) || (s.skills && s.skills.length));
  if (!hasContent) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Summary</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        {s.bullets && s.bullets.length > 0 && (
          <ul style={{ margin: '0 0 0.08in 0', paddingLeft: '0.22in' }}>
            {s.bullets.map((b, i) => (
              <li key={i} style={{ marginBottom: '0.04in' }}>{b}</li>
            ))}
          </ul>
        )}
        {s.tagline && template.italicTagline && (
          <div style={{ fontStyle: 'italic', margin: '0.05in 0 0.06in 0', color: '#2b2b2b' }}>
            {s.tagline}
          </div>
        )}
        {s.tagline && !template.italicTagline && (
          <div style={{ margin: '0.05in 0 0.06in 0', color: '#2b2b2b' }}>{s.tagline}</div>
        )}
        {s.skills && s.skills.length > 0 && (
          <div style={{
            fontFamily: template.monoSkills ? MONO_FACE : template.bodyFont,
            fontSize: template.monoSkills ? '9.5pt' : '10.5pt',
            color: '#1c1c1c',
            marginTop: '0.04in',
          }}>
            {template.pillSkills ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.06in' }}>
                {s.skills.map((sk, i) => (
                  <span key={i} style={{
                    border: `1px solid ${hexToRgba(accent, 0.4)}`,
                    color: accent,
                    padding: '0.02in 0.1in',
                    borderRadius: '0.05in',
                    fontSize: '9pt',
                    letterSpacing: '0.02em',
                  }}>{sk}</span>
                ))}
              </div>
            ) : (
              s.skills.join('  -  ')
            )}
          </div>
        )}
      </div>
    </div>
  );
}
